import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { setAlert } from '@store/alerts.reducer';

// success, error, info, warning
export const useAddAlert = () => {
	const d = useDispatch();
	return useCallback((data) => d(setAlert({ type: 'success', ...data })), [d]);
};
